const AnnouncementsTypes = {
    FETCH_ANNOUNCEMENTS_REQ: 'FETCH_ANNOUNCEMENTS_REQ',
    SET_ANNOUNCEMENTS: 'SET_ANNOUNCEMENTS',
};

export default AnnouncementsTypes;

export interface Announcement {
    dealName: string;
    dealUUID: string;
    details?: string;
    isDeleted: boolean;
    time: string;
    title: string;
    url: string;
    uuid: string;
}

export interface AnnoucementState {
    loading: boolean;
    annoucement: Announcement[];
}
